import { CustomsOfficeOfTransitDeclared } from 'features/declaration/models/schemas/commonConsignmentSchemas'
import { isTransitionalPeriodActive } from 'shared/ncts/common/constants'
import { excludeDeleted } from 'shared/lib/common-util'

const R0789Validator = {
  getActiveBorderTransportMeansMultiplicity: (transitCustomsOffices: CustomsOfficeOfTransitDeclared[]): number => {
    if (isTransitionalPeriodActive()) {
      return 1 // E1406
    }
    if (transitCustomsOffices.filter(excludeDeleted).length > 0) {
      return 9
    }

    return 1
  },

} as const

export default R0789Validator
